import { group } from '@/config/configuration';
import { SiteShell, SiteTalentspaceContent } from '@/sites/types';
import { wrktpTalentspace } from '@/sites/wrktp/content';
import { edunetTalentspace, edunetinTalentspace } from '@/sites/edunet/content';
import { jobnetagTalentspace } from '@/sites/jobnetag/content';

// Everything between the client's header and footer (navigation, pages, overlays) is shared
// by all sites. Per site only the shell, the brand texts and the theme tokens (colors from
// the site config / PAT, font from PAT) differ.

const jobnetagShell: SiteShell = {
  header: () => import('@/sites/jobnetag/JobnetagHeader.vue'),
  footer: () => import('@/sites/jobnetag/JobnetagFooter.vue'),
};

const edunetShell: SiteShell = {
  header: () => import('@/sites/edunet/EdunetHeader.vue'),
  footer: () => import('@/sites/edunet/EdunetFooter.vue'),
};

// Sites already moved to the Talentspace design
const talentspaceShells: Record<string, SiteShell> = {
  wrktp: {
    header: () => import('@/sites/wrktp/WrktpHeader.vue'),
    footer: () => import('@/sites/wrktp/WrktpFooter.vue'),
  },
  edunet: edunetShell,
  // edunet.in: the same site theme as edunet.works, its own content
  edunetin: edunetShell,
  // edunet.ke: the same site theme, its own content
  edunetke: edunetShell,
  // edunet.co.ma: the same site theme, its own content
  edunetma: edunetShell,
  // jobnet.ag shell, shared by talentspace.jobnet.ag, talentspace.jobnet.at and talentpool.eu
  jnjts: jobnetagShell,
  jnjtsat: jobnetagShell,
  jnjtseu: jobnetagShell,
};

const capitalize = (sid: string) => sid.charAt(0).toUpperCase() + sid.slice(1);

// Not moved yet: the legacy theme components, found by the old naming convention
const legacyShell = (sid: string): SiteShell => {
  if (!group(sid)) {
    return {
      header: () => import('@/components/Layout/InformationNavigation.vue'),
      footer: () => import('@/components/Layout/FooterComponent.vue'),
    };
  }
  const name = capitalize(sid);
  return {
    header: () => import(`@/components/Themes/HeaderInformationNavigation${name}.vue`),
    footer: () => import(`@/components/Themes/FooterComponent${name}.vue`),
  };
};

export const isTalentspaceSite = (sid: string): boolean => sid in talentspaceShells;

export const siteShell = (sid: string): SiteShell => talentspaceShells[sid] || legacyShell(sid);

const talentspaceContent: Record<string, SiteTalentspaceContent> = {
  wrktp: wrktpTalentspace,
  edunet: edunetTalentspace,
  edunetin: edunetinTalentspace,
  edunetke: edunetinTalentspace,
  edunetma: edunetinTalentspace,
  jnjts: jobnetagTalentspace,
  jnjtsat: jobnetagTalentspace,
  jnjtseu: jobnetagTalentspace,
};

export const siteContent = (sid: string): SiteTalentspaceContent => talentspaceContent[sid] || {};
